import {
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import moment from "moment";
import { GoInfo } from "react-icons/go";
import { Enumerations } from "../../config/Enumerations";
import { getEntryStatusColor } from "../common/VisualElementsHelper";
import { useNavigate } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";

export default function EntryTable({
  loading,
  data,
  handleChangePage,
  handleChangeRowsPerPage,
}) {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <TableContainer>
      <Table size="small" style={{ marginTop: "20px" }}>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography
                variant="subtitle1"
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "13px",
                  lineHeight: "1.1",
                }}
              >
                Број на запис
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant="subtitle1"
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "13px",
                  lineHeight: "1.1",
                }}
              >
                Идентификатор на барањето
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant="subtitle1"
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "12px",
                  lineHeight: "1.1",
                  color: "#333",
                }}
              >
                Подносител
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant="subtitle1"
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "12px",
                  lineHeight: "1.1",
                  color: "#333",
                }}
              >
                Време на поднесување
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant="subtitle1"
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "12px",
                  lineHeight: "1.1",
                  color: "#333",
                }}
              >
                Статус
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant="subtitle1"
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "12px",
                  lineHeight: "1.1",
                  color: "#333",
                }}
              >
                Тип на барање
              </Typography>
            </TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        {loading && (
          <TableBody>
            <TableRow>
              <TableCell colSpan={7} align="center" style={{ padding: "40px" }}>
                <CircularProgress />
              </TableCell>
            </TableRow>
          </TableBody>
        )}

        {!loading && data?.content?.length === 0 && (
          <TableBody>
            <TableRow>
              <TableCell colSpan={7} align="center" style={{ padding: "5px" }}>
                <Typography
                  variant="body2"
                  style={{
                    fontFamily: "Inter-Regular",
                    fontSize: "12px",
                    lineHeight: "1.1",
                  }}
                >
                  <i>Нема податоци</i>
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        )}

        {!loading && (
          <>
            <TableBody>
              {data?.content?.map((entry, index) => (
                <TableRow
                  key={index}
                  sx={{
                    cursor: "pointer",
                    backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
                    borderLeft: `5px solid ${getEntryStatusColor(
                      entry.status
                    )}`,
                    "&:hover": {
                      backgroundColor: "#ededed",
                    },
                  }}
                  onClick={() => {
                    navigate(`/entries/details/${entry.id}`);
                  }}
                >
                  <TableCell sx={{ py: 1 }}>
                    <Typography
                      style={{
                        fontFamily: "Inter-Regular",
                        fontSize: "14px",
                        lineHeight: "1.1",
                      }}
                    >
                      {entry?.entryNumber}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ py: 1 }}>
                    <Typography
                      style={{
                        fontFamily: "Inter-Regular",
                        fontSize: "14px",
                        lineHeight: "1.1",
                      }}
                    >
                      {entry?.trackingNumber}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ py: 1 }}>
                    <Typography
                      variant="body2"
                      style={{
                        fontFamily: "Inter-Regular",
                        fontSize: "14px",
                        lineHeight: "1.1",
                      }}
                    >
                      {entry?.appEntryData?.applicantName}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ py: 1 }}>
                    <Typography
                      variant="body2"
                      style={{
                        fontFamily: "Inter-Regular",
                        fontSize: "14px",
                        lineHeight: "1.1",
                      }}
                    >
                      {moment(entry?.dateSubmitted).format("DD.MM.YYYY HH:mm")}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ py: 1 }}>
                    <Typography
                      variant="body2"
                      style={{
                        fontFamily: "Inter-Regular",
                        fontSize: "14px",
                        lineHeight: "1.1",
                      }}
                    >
                      {Enumerations.AppEntryStatus[entry?.status] ||
                        entry?.status}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ py: 1 }}>
                    <Typography
                      variant="body2"
                      style={{
                        fontFamily: "Inter-Regular",
                        fontSize: "14px",
                        lineHeight: "1.1",
                      }}
                    >
                      {Enumerations.AppEntryTypeDisplay[entry?.type] ||
                        entry?.type}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <IconButton style={{ padding: 0 }}>
                      <IoIosArrowForward
                        size={16}
                        color={theme.palette.primary.main}
                        style={{ padding: 0 }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter
              style={{
                position: "sticky",
                bottom: 0,
                background: "white",
              }}
            >
              <TableRow>
                <TablePagination
                  style={{ borderBottom: "none" }}
                  rowsPerPageOptions={[5, 10, 25]}
                  colSpan={8}
                  count={data?.totalElements ?? 0}
                  rowsPerPage={data?.size ?? 10}
                  page={data?.number ?? 0}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </>
        )}
      </Table>
    </TableContainer>
  );
}
